// @flow

const stripeInputStyles = {
  root: (theme) => ({
    width: '100%',
    padding: '6px 0 7px',
    cursor: 'text'
  })
};

export default stripeInputStyles;
